import { enqueueSnackbar } from '@applift/factor'

export const copyText = (text: string, successText: string) => {
  navigator.clipboard.writeText(text).then(() => {
    enqueueSnackbar(successText, {
      variant: 'success',
    })
  })
}
